import { render, staticRenderFns } from "./SettingsBots.vue?vue&type=template&id=f9545792&scoped=true&"
import script from "./SettingsBots.vue?vue&type=script&lang=js&"
export * from "./SettingsBots.vue?vue&type=script&lang=js&"
import style0 from "./SettingsBots.vue?vue&type=style&index=0&id=f9545792&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9545792",
  null
  
)

export default component.exports